import { render, staticRenderFns } from "./PublishingContacts.vue?vue&type=template&id=21e3bfcd&scoped=true&"
import script from "./PublishingContacts.vue?vue&type=script&lang=ts&"
export * from "./PublishingContacts.vue?vue&type=script&lang=ts&"
import style0 from "./PublishingContacts.vue?vue&type=style&index=0&id=21e3bfcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3bfcd",
  null
  
)

export default component.exports